import { ImportKapiInstanceByNameResponse as ProtoImportInstanceByNameResponse } from "@opstel/gen/knop/ui/v1/api/instance_loading_pb";
import { KapiNotification, kapiNotificationSchema } from "../models/kapiNotification";
import { createSchema, ZodOutputFor } from "../zod-utils";
import { PlainMessage } from "@bufbuild/protobuf";
import { z } from "zod/v3";
import { ResponseStatus, responseStatusSchema } from "./util/responseStatus";

export interface ImportKapiInstanceByNameResponse {
  status: ResponseStatus;
  instanceId: string;
  notifications: KapiNotification[];
  correlationOperationId: string;
  correlationParentId: string;
  correlationCurrentId: string;
}
export const importKapiInstanceByNameResponseSchema = createSchema<
  ImportKapiInstanceByNameResponse,
  PlainMessage<ProtoImportInstanceByNameResponse>
>({
  status: responseStatusSchema,
  description: z.string(),
  instanceId: z.string(),
  notifications: z.array(kapiNotificationSchema),
  correlationOperationId: z.string(),
  correlationParentId: z.string(),
  correlationCurrentId: z.string(),
}).refine(
  (message) =>
    message.status !== "SUCCESS" || z.string().uuid().safeParse(message.instanceId).success,
  {
    message: "instance should have a valid guid as instance id",
  },
) as ZodOutputFor<ImportKapiInstanceByNameResponse>;
